import styled from '@emotion/styled'

import { Caption, LoaderOuter, StyledButton, StyledLink, Title } from './sharedStyles'
import CircularLoader from 'components/CircularLoader'
import InfoBanner from 'components/InfoBanner'

const InfoOuter = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spaces.space3};
	height: 100%;
`

type Props = {
	selectedAction: 'add to workspace' | 'publish' | null
	hideModal: () => void
	isSaving: boolean
	selectedAccountId: string | null
	selectedContainerId: string | null
	selectedWorkspaceId: string | null
	selectedContainerName: string | null
}

const ActionCompletionStep = ({
	selectedAction,
	hideModal,
	isSaving,
	selectedAccountId,
	selectedContainerId,
	selectedWorkspaceId,
	selectedContainerName,
}: Props) => {
	const finishSetup = () => {
		hideModal()
	}

	if (isSaving) {
		return (
			<LoaderOuter>
				<CircularLoader size="xlarge" data-testid="gtm-saving-loader" />
			</LoaderOuter>
		)
	}

	return (
		<>
			{selectedAction === 'add to workspace' ? (
				<>
					<Title>OpenWidget has been succesfully added to your workspace</Title>
					<InfoOuter>
						<InfoBanner title="Review changes before publishing">
							{`Note that the workspace currently includes some unpublished changes. To ensure everything is in order, visit `}
							<StyledLink
								href={`https://tagmanager.google.com/#/container/accounts/${selectedAccountId}/containers/${selectedContainerId}/workspaces/${selectedWorkspaceId}`}
								target="_blank"
								rel="noreferrer"
							>
								{selectedContainerName}
							</StyledLink>
							{`'s `}
							{`workspace and review these changes.`}
						</InfoBanner>
						<StyledButton kind="primary" onClick={finishSetup}>
							Done
						</StyledButton>
					</InfoOuter>
				</>
			) : (
				<>
					<Title>OpenWidget has been succesfully published</Title>
					<InfoOuter>
						<Caption>
							You can now test the widget on the website linked to the workspace where OpenWidget was added.
						</Caption>
						<StyledButton kind="primary" onClick={finishSetup}>
							Done
						</StyledButton>
					</InfoOuter>
				</>
			)}
		</>
	)
}

export default ActionCompletionStep
